import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { PalletGateway } from 'src/app/application/gateway/PalletGateway';
import { PalletStockGateway } from 'src/app/application/gateway/PalletStockGateway';
import { AssignPalletStockRequest, FormatPalletStock, GroupPalletStock, GroupPalletStockRequest, PalletStock, PalletStockFilterRequest, Stock, StockColumn } from 'src/app/domain/models/PalletStock';
import { PropertiesPalletStock } from '../../util/pallet-stock-properties';
import { ErrorMessageUtil } from '../../util/error-message-util';
import { DirectSaleProgramGateway } from 'src/app/application/gateway/DirectSaleProgramGateway';

@Component({
  selector: 'app-assign-stock',
  templateUrl: './assign-stock.component.html',
  styleUrls: ['./assign-stock.component.css'],

})
export class AssignStockComponent implements OnInit, OnChanges {

  @Input()
  orderDetailGuid: string | undefined

  @Input()
  programOrderGuid: string | undefined

  @Input()
  editProgramFromStock: boolean = false;

  loading: boolean = false;
  stock: Stock[] = [];

  //palletStock: PalletStock[] = [];
  groupPalletStock: GroupPalletStock[] = [];
  filteredGroupPalletStock: GroupPalletStock[] = [];

  stockId: number | undefined;
  selectedPalletStock: PalletStock[] = []
  uniquePalletStockSelected: string[] = []
  uniquePalletStock: number = 0;
  searchTerm: string = '';

  @Input()
  isOrderLoad: boolean = false;

  @Input()
  isProgramLoad: boolean = false;

  @Output()
  onAssignStock: EventEmitter<any> = new EventEmitter();

  @Output()
  onCancelAssignStock: EventEmitter<any> = new EventEmitter();

  columns = PropertiesPalletStock;
  stockColumns: StockColumn[] = []

  selectedPalletStockMap: { [groupIndex: string]: PalletStock[] } = {};
  selectedGroupCheck: { [groupIndex: string]: boolean[] } = {};

  withProducer: boolean = true;
  withCategory: boolean = false;
  withSpeciesSize: boolean = false;
  withPalletNumber: boolean = true;
  withContainer: boolean = false;
  withProgramName: boolean = false;

  // Valores aplicados: solo se actualizan al presionar el buscador, controlan columnas visibles y el request
  appliedWithProducer: boolean = true;
  appliedWithCategory: boolean = false;
  appliedWithSpeciesSize: boolean = false;
  appliedWithPalletNumber: boolean = true;
  appliedWithContainer: boolean = false;
  appliedWithProgramName: boolean = false;

  totalCases: number = 0;
  totalPallets: number = 0;

  totalCount = 0;
  pageSize = 10;

  filter: PalletStockFilterRequest = {
    containerFilter: [],
    statusFilter: [],
    speciesFilter: [],
    growerFilter: [],
    speciesSizeFilter: [],
    varietyFilter: [],
    stockId: 0,
    programNameFilter: []

  }

  globalFilters: string[] = ['palletNumber','species', 'variety', 'container', 'producer', 'speciesSize', 'status' ]

  constructor(
    private _palletStockService: PalletStockGateway,
    private _messageService: MessageService,
    public translate: TranslateService,
    private _palletService: PalletGateway,
    private _directSaleProgramService: DirectSaleProgramGateway
  )
  {

  }

  ngOnInit(): void {
    // this.getStock()
  }

  ngOnChanges(changes: SimpleChanges): void {

    if(changes['programOrderGuid'] || changes['orderDetailGuid'] )
    {
       this.getStock();
       this.selectedPalletStock = []
       this.selectedPalletStockMap = {}
    }

    if(changes['groupPalletStock']){
      this.summaryData()
    }
  }

  getStock()
  {
    this.loading = true;
    this._palletStockService.getStock().subscribe({
      next: (v) => {
        this.stock = v;
        if(this.stock.length > 0){
          this.stockId = this.stock[0].id
          this.getPalletStock()
        }
        this.loading = false;
      },
      error: (e) => {
        console.log(e)
        this.loading = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.PalletStock.GetStockError') })
      }
    })
  }

  getPalletStockPaged(event: any)
  {
    const pageNumber = Math.floor(event.first / event.rows) + 1;
    const pageSize = event.rows;

    this.getPalletStock(pageSize, pageNumber);
  }

  changeGroup()
  {
    this.cleanSelection()
    //this.getPalletStock()
  }

  searchPalletStock()
  {
    this.appliedWithPalletNumber = this.withPalletNumber;
    this.appliedWithCategory = this.withCategory;
    this.appliedWithSpeciesSize = this.withSpeciesSize;
    this.appliedWithProducer = this.withProducer;
    this.appliedWithContainer = this.withContainer;
    this.appliedWithProgramName = this.withProgramName;
    this.getPalletStock()
  }

  getPalletStock(pageSize: number = 10, pageNumber: number = 1)
  {
    if(this.stockId)
    {
      this.cleanSelection()
      this.groupPalletStock = []
      this.filteredGroupPalletStock = []
        this.loading = true;
        var groupPalletRequest: GroupPalletStockRequest = {
          stockId: this.stockId,
          withPalletNumber: this.appliedWithPalletNumber,
          withCategory: this.appliedWithCategory,
          withSpecieSize: this.appliedWithSpeciesSize,
          withProducer: this.appliedWithProducer,
          withContainer: this.appliedWithContainer,
          pageSize,
          pageNumber,
          containerFilter: this.filter.containerFilter,
          speciesSizeFilter: this.filter.speciesSizeFilter,
          statusFilter: this.filter.statusFilter,
          growerFilter: this.filter.growerFilter,
          speciesFilter: this.filter.speciesFilter,
          varietyFilter: this.filter.varietyFilter,
          programNameFilter: this.filter.programNameFilter,
          withProgramName: this.appliedWithProgramName
        }

        this._palletStockService.getGroupPalletStock(groupPalletRequest).subscribe({
          next: (v) => {
            this.loading = false;
            this.groupPalletStock = v.items;
            this.totalCount = v.totalCount;
            this.getColumns()
            this.summaryData()
          },
          error: (e) => {
            this.loading = false
            this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.PalletStock.GetStockError') })
          }
      })
    }

  }

  getPalletStats()
  {
    if(this.stockId)
    {
      this._palletStockService.getPalletStockStats(this.stockId).subscribe({
        next: (v) => {
            this.totalCases = v.totalCases;
            this.uniquePalletStock = v.totalPallets;
        },
        error: (e) => {
            this.loading = false
            this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.PalletStock.GetStockError') })
        }
      })

    }
  }

  assignStock()
  {
    if(this.isOrderLoad)
    {
      this.assignStockOrder();
    }else if(this.editProgramFromStock)
    {
      this.editProgram();
    }else{
      this.assignStockProgram();
    }
  }

  cleanSelection()
  {
    this.selectedPalletStockMap = {}
    this.selectedGroupCheck = {};
    this.uniquePalletStockSelected = [];
  }

  getColumns()
  {
    this.loading = true;
    if(this.stockId)
    {
      this._palletStockService.getStockFormatColumns(this.stockId).subscribe({
        next: (v) => {
          this.stockColumns = v;
          this.loading = false;
        },
        error: (e) => {
          this.loading = false
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.PalletStock.GetStockColumnsError') })
        }
      })
    }

  }

  assignStockOrder()
  {
    var allSelected = this.getAllSelectedPallets()
    if(this.orderDetailGuid && allSelected.length > 0)
    {
      this.loading = true;
      var palletStockIds = this.convertToAssignPallet(allSelected);
      this._palletService.assignPalletStockOrder(palletStockIds, this.orderDetailGuid).subscribe({
        next: (v) => {
          this.loading = false;
            this.loading = false
            this.selectedPalletStock = []
            this.cleanSelection()
            this.getPalletStock()
            if(v?.length == 0)
            {
              this._messageService.add({ severity: 'success',
              summary: this.translate.instant('MessageService.Summary.SuccessAction'),
              detail: this.translate.instant('MessageService.PalletStock.AssignPalletStockOrderSuccess') })
              this.loading = false
              this.selectedPalletStock = []
            }else{
              this._messageService.add({ severity: 'warn',
              summary: this.translate.instant('MessageService.Summary.ParcialAction'),
              detail: this.translate.instant('MessageService.PalletStock.StockAlertWarning') })
              this.loading = false
              this.selectedPalletStock = []
            }
        },
        error: (e) => {
            this.loading = false
            this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.PalletStock.AssignPalletStockOrderError') })
          },
          complete: () => {
              this.onAssignStock.emit();
          }
      })
    }
    else {
      this._messageService.add({ severity: 'error',
        summary: this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant('MessageService.PalletStock.AssignedPalletError')
      })
    }
  }

  assignStockProgram()
  {
    var allSelected = this.getAllSelectedPallets()
    if(this.programOrderGuid && allSelected.length > 0)
    {
      this.loading = true;
      var palletStockIds =  this.convertToAssignPallet(allSelected);
      this._palletService.assignPalletStockProgram(palletStockIds, this.programOrderGuid).subscribe({
        next: (v) => {
          this.loading = false;
          this.cleanSelection()
          if(v?.length == 0)
          {
            this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: this.translate.instant('MessageService.PalletStock.AssignPalletStockOrderSuccess') })
            this.loading = false
            this.selectedPalletStock = []
          }else{
            this._messageService.add({ severity: 'warn',
            summary: this.translate.instant('MessageService.Summary.ParcialAction'),
            detail: this.translate.instant('MessageService.PalletStock.StockAlertWarning') })
            this.loading = false
            this.selectedPalletStock = []
          }
          this.getPalletStock()

        },
        error: (e) => {
            this.loading = false
            this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: ErrorMessageUtil.getResponseError(e,
              this.translate.currentLang,
              this.translate.instant('MessageService.PalletStock.AssignPalletStockOrderError') )  })
          },
        complete: () => {
            this.onAssignStock.emit();
        }
      })
    }
    else {
      this._messageService.add({ severity: 'error',
        summary: this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant('MessageService.PalletStock.AssignedPalletError')
      })
    }
  }

  editProgram()
  {
    var allSelected = this.getAllSelectedPallets()
     if(this.programOrderGuid && allSelected.length > 0)
    {
      this.loading = true;
      var palletStockIds =  this.convertToAssignPallet(allSelected);
      this._directSaleProgramService.editPalletStockWithProgram(palletStockIds, this.programOrderGuid).subscribe({
        next: (v) => {
          this.loading = false;
          this.cleanSelection()
          if(v?.length == 0)
          {
            this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: this.translate.instant('MessageService.PalletStock.AssignPalletStockOrderSuccess') })
            this.loading = false
            this.selectedPalletStock = []
          }else{
            this._messageService.add({ severity: 'warn',
            summary: this.translate.instant('MessageService.Summary.ParcialAction'),
            detail: this.translate.instant('MessageService.PalletStock.StockAlertWarning') })
            this.loading = false
            this.selectedPalletStock = []
          }
          this.getPalletStock()

        },
        error: (e) => {
            this.loading = false
            this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: ErrorMessageUtil.getResponseError(e,
              this.translate.currentLang,
              this.translate.instant('MessageService.PalletStock.AssignPalletStockOrderError') )  })
          },
        complete: () => {
            this.onAssignStock.emit();
        }
      })
    }else {
      this._messageService.add({ severity: 'error',
        summary: this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant('MessageService.PalletStock.AssignedPalletError')
      })
    }
    this.onAssignStock.emit();
  }

  cancelAssignStockCancel()
  {
    this.onCancelAssignStock.emit();
  }

  @ViewChild('palletStockTable') dt: any;
  configFilter(event: any)
  {
    this.filter = {... event}
    //this.getPalletStock()
  }

  configFilterSearch()
  {
    if(!this.searchTerm.trim())
    {
      this.filteredGroupPalletStock = this.groupPalletStock

    }else{
      this.filteredGroupPalletStock = this.groupPalletStock.filter(group => {
      group.palletNumber?.toLocaleLowerCase().includes(this.searchTerm.toLocaleLowerCase())||
      group.species?.toLocaleLowerCase().includes(this.searchTerm.toLocaleLowerCase()) ||
      group.variety?.toLocaleLowerCase().includes(this.searchTerm.toLocaleLowerCase()) ||
      group.container?.toLocaleLowerCase().includes(this.searchTerm.toLocaleLowerCase()) ||
      group.speciesSize?.toLocaleLowerCase().includes(this.searchTerm.toLocaleLowerCase()) ||
      group.producer?.toLocaleLowerCase().includes(this.searchTerm.toLocaleLowerCase())
     });
    }

  }

  onSelectRowHandler(event: any)
  {
    if(this.uniquePalletStockSelected.findIndex((x) => x == event.data.palletNumber) == -1){
        this.uniquePalletStockSelected.push(event.data.palletNumber)
    }
  }

  getAllSelectedPallets(): PalletStock[] {

    return Object.values(this.selectedPalletStockMap).flat();
  }

  convertToAssignPallet(pallets: PalletStock[]): AssignPalletStockRequest
  {
    var result: AssignPalletStockRequest =  pallets.reduce((acc, item) => {
      if (!item.palletNumber) return acc; // Ignorar si no tiene palletNumber

      if (!acc[item.palletNumber]) {
        acc[item.palletNumber] = [];
      }

      acc[item.palletNumber].push(item.id);

      return acc;
    }, {} as { [palletNumber: string]: number[] });

    return result;
  }

  isRowDisabled(rowData: PalletStock): boolean {
  // Por ejemplo, deshabilitar si el estado es 'usado' o 'despachado'
    if(this.editProgramFromStock)
    {
      return false;
    }
    return rowData.status === 1 || rowData.status === 2;
  }

  toggleAllSelectableRows(event: any, index: string) {

    let indexGroup = this.groupPalletStock.findIndex(x => x.groupIndex == index);
    const allSelectable = this.groupPalletStock[indexGroup].palletStock.filter(row => !this.isRowDisabled(row));
    if (event.checked) {
      this.selectedPalletStockMap[index] = [...allSelectable];
      allSelectable.forEach(x => {
        if(!this.uniquePalletStockSelected.includes(x.palletNumber)){
          this.uniquePalletStockSelected.push(x.palletNumber);
        }
      })
    } else {
      this.selectedPalletStockMap[index] = [];
      allSelectable.forEach(x => {
        this.uniquePalletStockSelected = this.uniquePalletStockSelected.filter(p => p != x.palletNumber);
      })
    }
  }

  summaryData()
  {
    this.getPalletStats();
  }

  get totalCasesSelected(): number
  {
    let total = 0;

    Object.keys(this.selectedPalletStockMap).forEach(key => {
      const groupIndex = key;
      const palletStocks = this.selectedPalletStockMap[groupIndex];

      palletStocks.forEach(stock => {
        // let valor = !isNaN(Number(stock.excelImportBoxesPerPallet))
        // ? Number(stock.excelImportBoxesPerPallet) : 0;

        total += stock.convertBoxesPerPallet;
      });
    });

    return total;
  }

  get isSelectedPalletStock(): boolean {
    let selected = false;
    Object.values(this.selectedGroupCheck).forEach(key => {
      if (key) selected = true;
    });

    return selected;
  }
}
